import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
// CSS
import { LoadingIndicator } from '@dojo/widgets/loading-indicator';
import { Card } from '@holmescorp/card';
import { createNlsMiddleware } from '@holmescorp/lcc-state';

import css from '../../css/nav-card.m.css';

export interface LoadingCardProperties {
	xqa?: string;
}

const nls = createNlsMiddleware('ditabook');
const factory = create({
	theme,
	nls
}).properties<LoadingCardProperties>();

export const LoadingCard = factory(({ id, properties, middleware: { theme, nls } }) => {
	const themeCss = theme.classes(css);
	const { xqa } = properties();
	const {
		messages: { loadingCardTitle = '(ditabook) loadingCardTitle' }
	} = nls();

	return v('div', { id, classes: [theme.variant()] }, [
		w(Card, { xqa }, [
			{
				content: v('div', { classes: [themeCss.loading_card] }, [
					v('div', { classes: [themeCss.title] }, [loadingCardTitle]),
					v('div', { classes: [themeCss.actions] }, [
						w(LoadingIndicator, { key: 'loading', type: 'circular-medium' })
					])
				])
			}
		])
	]);
});
export default LoadingCard;
